import { createGlobalStyle } from 'styled-components'
import {
  mediaMax,
  mediaMin,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'

const GlobalStyle = createGlobalStyle`
  :root {
  }
  html, body{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-size: ${calculateResponsiveSize(14)};
    color: #efebe5;
    line-height: 1.25;
    background: #182c49;
    min-width: 320px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    scrollbar-color: #efebe5 #182c49;
    &::-webkit-scrollbar-track {
      background: #182c49;
    }
    &::-webkit-scrollbar-thumb {
      background: #efebe5;
    }
    ${mediaMax('mobile')} {
      font-size: ${calculateMobileResponsiveSize(14)};
    }
    color-scheme: dark;
  }
  body{
    overflow-y: scroll;
    overscroll-behavior-y: none;
  }
  body.hidden {
    height: 100dvh !important;
  }
  ${mediaMax('mobile')} {
    body.hidden {
      overflow: hidden;
    }
  }
  body.hidden .home-wrapper {
    height: 100dvh;
    overflow: hidden;
  }
  html, body, A, input, select, textarea, button{
    font-family: 'Quasimoda', Arial, Tahoma, Geneva, Kalimati, sans-serif;
  }
  A{
    text-decoration: none;
    color: #efebe5;
    outline: none;
  }
  A:hover{
    text-decoration: underline;
  }
  input, select, textarea {
    vertical-align: top;
    outline: none;
  }
  /* ----- Safari profile icon ----- */
  input::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
  textarea {
    resize: vertical;
  }
  *{ -webkit-tap-highlight-color: transparent; box-sizing: border-box; }
  img, object, iframe, svg{ border: 0; vertical-align: top; }
  button { font-weight: 400; }
  ${mediaMin('mobile')} {
    .home-content {
      will-change: transform;
    }
  }
  /* ----- react-select ----- */
  @keyframes selectSlideInOut {
    0% {
      transform: translateY(-1px);
    }
    100% {
      transform: translateY(0);
    }
  }

  /* ----- For br ----- */
  .for-mobile {
    display: none;
  }
  ${mediaMax('mobile')} {
    .for-desktop {
      display: none;
    }
    .for-mobile {
      display: inline;
    }
  }

  /* ----- Animations ----- */
  .fadeIn {
    transform: translateY(100px);
    opacity: 0;
    transition: transform 1.25s, opacity 1.25s;
    &.visible {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export default GlobalStyle
